
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 171 34","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_28860_30081)"}},[_c('path',{attrs:{"d":"M31.907.981H0V33.09h31.907V.981zM66.473.981H34.566V33.09h31.907V.981zM101.039.981H69.132V33.09h31.907V.981zM135.606.981h-31.908V33.09h31.908V.981zM170.172.981h-31.908V33.09h31.908V.981z","fill":"#00B67A"}}),_c('path',{attrs:{"d":"M170.172.981h-2.708V33.09h2.708V.981z","fill":"#E6E7E9"}}),_c('path',{attrs:{"d":"M15.954 22.62l4.853-1.237 2.027 6.288-6.88-5.05zm11.168-8.127H18.58l-2.626-8.094-2.626 8.094H4.787L11.7 19.51l-2.626 8.094 6.913-5.017 4.255-3.077 6.88-5.017zM50.52 22.62l4.853-1.237L57.4 27.67l-6.88-5.05zm11.168-8.127h-8.542L50.52 6.399l-2.626 8.094h-8.541l6.913 5.017-2.626 8.094 6.913-5.017 4.255-3.077 6.88-5.017zM85.086 22.62l4.853-1.237 2.027 6.288-6.88-5.05zm11.168-8.127h-8.542l-2.626-8.094-2.625 8.094h-8.542l6.913 5.017-2.626 8.094 6.914-5.017 4.254-3.077 6.88-5.017zM119.652 22.62l4.853-1.237 2.027 6.288-6.88-5.05zm11.168-8.127h-8.542l-2.626-8.094-2.625 8.094h-8.542l6.913 5.017-2.626 8.094 6.914-5.017 4.254-3.077 6.88-5.017zM154.219 22.62l4.852-1.237 2.028 6.288-6.88-5.05zm11.167-8.127h-8.542l-2.625-8.094-2.626 8.094h-8.542l6.913 5.017-2.625 8.094 6.913-5.017 4.254-3.077 6.88-5.017z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_28860_30081"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .981)","d":"M0 0h170.172v32.108H0z"}})])])])
          )
        }
      }
    